import React from 'react';
import { MEDIA_BREAKPOINTS } from '../../../../constants/MEDIA_BREAKPOINTS';
export const MainBannerSkeleton = ({ imgHeight, imgWidth }) => {
    if (MEDIA_BREAKPOINTS.MD_UP.matches) {
        return (React.createElement("div", { className: "d:flex mb:28 mb:44:xl-up skeleton" },
            React.createElement("div", { className: "w:5/12" }),
            React.createElement("div", { className: "fx:1", style: {
                    aspectRatio: `${imgWidth} / ${imgHeight}`
                } })));
    }
    return (React.createElement("div", { className: "mb:28" },
        React.createElement("div", { className: "skeleton w:100vw mx:-pw", style: {
                aspectRatio: `${imgWidth} / ${imgHeight}`
            } }),
        React.createElement("div", { className: "py:24" },
            React.createElement("div", { className: "skeleton fz:20 pb:6 h:lh w:1/3 mx:auto" }),
            React.createElement("div", { className: "fz:14 lh:1.7 d:flex fd:column ai:center" },
                React.createElement("div", { className: "skeleton h:lh w:4/5" }),
                React.createElement("div", { className: "skeleton h:lh w:3/5" }),
                React.createElement("div", { className: "skeleton h:lh w:1/3" })))));
};
